export const TEST_PATH = "/tests/:id";
